import React, { useContext } from 'react';
import { Card } from 'react-bootstrap';
import { STEP_STYLE, STEP_BODY_STYLE } from './stepStyle';
import { useWizard } from 'react-use-wizard';
import { Button } from '../util/buttons';
export default function CardStep(_ref) {
  let {
    title,
    children,
    NavigationContext,
    showFooterNavigation = false,
    onBeforeNextPage,
    onBeforePreviousPage,
    canProceed = true,
    showNextButton = true
  } = _ref;
  const {
    isFirstStep,
    isLastStep,
    nextStep,
    previousStep
  } = useWizard();
  const navigationDirection = useContext(NavigationContext);
  const goBack = () => {
    onBeforePreviousPage && onBeforePreviousPage();
    navigationDirection.current = -1; // Going backward animation
    previousStep();
  };
  const goNext = () => {
    onBeforeNextPage && onBeforeNextPage();
    navigationDirection.current = 1;
    nextStep();
  };
  const shouldUseDefaultNavigation = showFooterNavigation;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Card, {
    style: STEP_STYLE
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Card.Title, null, title)), /*#__PURE__*/React.createElement(Card.Body, {
    style: STEP_BODY_STYLE
  }, children), /*#__PURE__*/React.createElement(Card.Footer, null, shouldUseDefaultNavigation && /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-row justify-content-between h-100"
  }, !isFirstStep && /*#__PURE__*/React.createElement("div", {
    className: "mt-auto d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goBack
  }, "Go Back")), !isLastStep && showNextButton && /*#__PURE__*/React.createElement("div", {
    className: "mt-auto ms-auto"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goNext,
    disabled: !canProceed
  }, "Next"))))));
}